import React from 'react';
import {useRouteMatch} from "react-router-dom";
import {useIntl} from "react-intl";

function GetRouteFromUrl() {
    // Load the routes for the specific country.
    const routesCore = require(`../../config/core/client.routes.json`);
    let routesOpCo = {};
    try {
        routesOpCo = require(`../../config/${process.env.REACT_APP_COUNTRY}/client.routes.json`);
    }
    catch (e) {}
    const routes = {
        ...routesCore,
        ...routesOpCo
    };

    let {locale} = useIntl();
    const currentUrl = useRouteMatch().path;
    const clientRoutes = routes[locale];
    for (const name in clientRoutes) {
        if (clientRoutes.hasOwnProperty(name)) {
            const route = clientRoutes[name];
            if (route.url === currentUrl) {
                return {name, ...route}
            }
        }
    }
    return null;
}

export default GetRouteFromUrl;
